export default __webpack_public_path__ + "static/media/twoFactorAutoIcon.cfbcc533.svg";